var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58334 25.4479C9.58334 25.4479 10.8854 24.1458 14.7917 24.1458C18.6979 24.1458 21.3021 26.75 25.2083 26.75C29.1146 26.75 30.4167 25.4479 30.4167 25.4479V9.82293C30.4167 9.82293 29.1146 11.125 25.2083 11.125C21.3021 11.125 18.6979 8.52084 14.7917 8.52084C10.8854 8.52084 9.58334 9.82293 9.58334 9.82293V25.4479Z",
    stroke: "#272D45",
    strokeWidth: 3.64583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58334 32.4792V9.5625",
    stroke: "#272D45",
    strokeWidth: 3.64583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 28.125,
    fill: "transparent",
    transform: "translate(7.5 6.4375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.c0caf5f74a56f46dcbd2c2581db62e6d.svg";
export { ForwardRef as ReactComponent };